import { createSlice } from '@reduxjs/toolkit';
import Cookies from "js-cookie";

const initialState = {
    items: Cookies.get('items') ? JSON.parse(Cookies.get('items')) : [],
    totalItems: Cookies.get('totalItems') ? Number(Cookies.get('totalItems')) : 0,
    totalAmount: Cookies.get('totalAmount') ? Number(Cookies.get('totalAmount')) : 0,
};

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addCart: (state, action) => {
            const { product, store } = action.payload;
            const existingItem = state.items.find(item => item.product.id === product.id);
            console.log("product : ", product);
            console.log("store : ", store);
            console.log("Items : ", state.items);

            if (existingItem) {
                existingItem.product.quantity += 1;
            } else {
                state.items.push({
                    product: { ...product, quantity: 1 },
                    store,
                    price: Number(product.price) || 0
                });
                state.totalItems += 1;
            }

            state.totalAmount = state.items.reduce((total, item) => {
                return total + (Number(item.price) || 0) * (Number(item.product.quantity) || 0);
            }, 0);

            Cookies.set('items', JSON.stringify(state.items));
            Cookies.set('totalItems', state.totalItems.toString());
            Cookies.set('totalAmount', state.totalAmount.toString());

            //console.log("Updated Cart Items: ", JSON.parse(JSON.stringify(state.items)));
        },

        removeCart: (state, action) => {
            const { id } = action.payload;
            const existingItem = state.items.find(item => item.product.id === id);

            if (existingItem) {
                if (existingItem.product.quantity > 1) {
                    existingItem.product.quantity -= 1;
                } else {
                    state.items = state.items.filter(item => item.product.id !== id);
                    state.totalItems -= 1;
                }
            }

            state.totalAmount = state.items.reduce((total, item) => {
                return total + (Number(item.price) || 0) * (Number(item.product.quantity) || 0);
            }, 0);

            Cookies.set('items', JSON.stringify(state.items));
            Cookies.set('totalItems', state.totalItems.toString());
            Cookies.set('totalAmount', state.totalAmount.toString());

            //console.log("Redux Item After Removal: ", JSON.parse(JSON.stringify(state.items)));
        },

        incrementQuantity: (state, action) => {
            const productId = action.payload;
            const item = state.items.find(item => item.product.id === productId);

            if (item) {
                item.product.quantity += 1;
                state.totalAmount += item.price;

                Cookies.set('items', JSON.stringify(state.items));
                Cookies.set('totalItems', state.totalItems.toString());
                Cookies.set('totalAmount', state.totalAmount.toString());

                //console.log("Increment Quantity Updated");
            }
        },

        decrementQuantity: (state, action) => {
            const productId = action.payload;
            const item = state.items.find(item => item.product.id === productId);

            if (item) {
                if (item.product.quantity > 1) {
                    item.product.quantity -= 1;
                    state.totalAmount -= item.price;
                } else {
                    state.items = state.items.filter(item => item.product.id !== productId);
                    state.totalItems -= 1;
                }
                state.totalAmount = state.items.reduce((total, item) => {
                    return total + (Number(item.price) || 0) * (Number(item.product.quantity) || 0);
                }, 0);

                Cookies.set('items', JSON.stringify(state.items));
                Cookies.set('totalItems', state.totalItems.toString());
                Cookies.set('totalAmount', state.totalAmount.toString());

                //console.log("Decrement Quantity Updated");
            }
        },

        removeItem: (state, action) => {
            const id = action.payload;
            //console.log("Items : ",state.items)
            state.items = state.items.filter(item => item.product.id !== id);
            //console.log("Items : ",state.items)
            state.totalItems -= 1;

            state.totalAmount = state.items.reduce((total, item) => {
                return total + (Number(item.price) || 0) * (Number(item.product.quantity) || 0);
            }, 0);

            Cookies.set('items', JSON.stringify(state.items));
            Cookies.set('totalItems', state.totalItems.toString());
            Cookies.set('totalAmount', state.totalAmount.toString());

            //console.log("Item removed from cart:", JSON.parse(JSON.stringify(state.items)));
        },
        removeAllItems: (state) => {
            state.items = [];
            state.totalItems = 0;
            state.totalAmount = 0;

            Cookies.set('items', JSON.stringify(state.items));
            Cookies.set('totalItems', state.totalItems.toString());
            Cookies.set('totalAmount', state.totalAmount.toString());
        }
    },
});

export const { addCart, removeCart, incrementQuantity, decrementQuantity, removeItem, removeAllItems } = cartSlice.actions;
export default cartSlice.reducer;
